class RefundHistoryController {
    isErrorCode (code) {
        switch (code) {
            case '200':
            case 'refund':
                return false;
        }

        return true;
    }

    hasTransactions () {
        return this.transactions && Object.keys(this.transactions).length > 0;
    }

    formatTime (utcTime) {
        let utc = moment.utc(utcTime);
        return utc.tz('Europe/London').format('LLLL');
    }

    isManual (log) {
        return !!log.details && log.details.transaction_id === 'Manual Refund';
    }
}

RefundHistoryController.$inject = [];

export default RefundHistoryController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/refund.history.controller.js